import { render, staticRenderFns } from "./cockpitSamplePanel.vue?vue&type=template&id=a5564f80&scoped=true"
import script from "./cockpitSamplePanel.vue?vue&type=script&lang=js"
export * from "./cockpitSamplePanel.vue?vue&type=script&lang=js"
import style0 from "./cockpitSamplePanel.vue?vue&type=style&index=0&id=a5564f80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5564f80",
  null
  
)

export default component.exports